<template>
  <div id="score">
    <div class="lv4Text" align="right" style="padding:10px 0">
      <router-link to="/help/2_1" class="lv4Text">
        <i class="far fa-question-circle fa-lg" style="margin-right:5px"></i>积分使用说明
      </router-link>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="我的积分">
        <el-row>
          <el-col :span="8" align="center">
            <div style="padding:10px 0">当前积分</div>
            <div style="padding: 20px 0">
              <i class="fas fa-donate fa-4x lv0Text"></i>
            </div>
            <div class="lv0Text" style="font-size: 30px">{{data.has_integral}}</div>
          </el-col>
          <el-col :span="16" align="center" style="padding: 0 50px;">
            <el-row :gutter="20">
              <el-col :span="6" style="padding-top: 50px;">
                <div class="lv3Text" style="margin: 20px 0;">累计获得</div>
                <div class="lv0Text" style="font-size: 20px;">{{data.all_integral}}</div>
              </el-col>
              <el-col :span="6" style="padding-top: 50px;">
                <div class="lv3Text" style="margin: 20px 0;">累计使用</div>
                <div class="lv0Text" style="font-size: 20px;">{{data.use_integral}}</div>
              </el-col>
              <el-col :span="6" style="padding-top: 50px;">
                <div class="lv3Text" style="margin: 20px 0;">已兑换数量</div>
                <div class="lv0Text" style="font-size: 20px;">{{data.conversion_num}}件</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div class="lv2Text" style="padding: 20px 50px;">
          <div class="lv3Text">新手任务</div>
          <div class="lv3Text">
            <div class="r1" v-for="(item,index) of myList" :key="index">
              <div>
                <div class="lv2Text">{{item.name}}</div>
                <div>积分+{{item.number}}</div>
              </div>
              <div class="btn2">
                <router-link :to="item.link" v-if="item.is_get==''">
                  <el-button type="primary" size="small">去做任务</el-button>
                </router-link>
                <el-button
                  type="primary"
                  size="small"
                  @click="get(item.id)"
                  v-if="item.is_get=='0'"
                >领取积分</el-button>
                <el-button v-if="item.is_get=='1'" type="primary" size="small" disabled>已领取</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="积分明细">
        <div>
          <div v-for="(item,index) in list" :key="index" style="padding:0 30px;">
            <el-row class="sRow">
              <el-col :span="12">
                <div>{{item.str}}</div>
                <div class="lv4Text">{{dayjs.unix(item.create_date).format("YYYY-MM-DD")}}</div>
              </el-col>
              <el-col :span="12">
                <div align="right">
                  <span style="color:#409EFF" v-if="_.toInteger(item.number)>0">{{"+"+item.number}}</span>
                  <span style="color:#F56C6C" v-if="_.toInteger(item.number)<0">{{item.number}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="pager" align="center">
          <el-pagination
            background
            hide-on-single-page
            layout="prev, pager, next"
            :total="total"
            @current-change="pageChange"
            :page-size="15"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      data: {},
      list: [],
      page: 1,
      total: 0,
      myList: []
    };
  },
  activated() {
    this.$store.state.user_location = "我的积分";
  },
  created() {
    this.initData();
    this.geting()
  },
  methods: {
    geting() {
      this.axios
        .get(this.serve + "/personal/integral_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.myList = res.data.data;
          for (var item of this.myList) {
            if (
              item.name == "设置头像" ||
              item.name == "完善个人信息" ||
              item.name == "设置兴趣分类"
            ) {
              item.link = "/user/userinfo/0";
            } else if (
              item.name == "首次购物成功" ||
              item.name == "首次评价完成"
            ) {
              item.link = "/";
            } else if (item.name == "邀请好友注册") {
              item.link = "/user/invit/0";
            } else {
              item.link = "/user/orders/1";
            }
          }
        });
    },
    get(id) {
      this.axios
        .get(this.serve + "/personal/get_integral", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            integral_id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.initData();
            this.$message({
              message: "已领取积分",
              type: "success"
            });
            this.geting()
          }
        });
    },
    pageChange(p) {
      this.page = p;
      this.axios
        .get(this.serve + "/personal/integral_log", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: this.page
          }
        })
        .then(res => {
          if (res.data.data) {
            this.list = res.data.data.results;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/personal/integral_detail", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data = res.data.data;
          }
        });
      this.axios
        .get(this.serve + "/personal/integral_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.data) {
            this.myList = res.data.data;
            for (var item of this.myList) {
              if (
                item.name == "设置头像" ||
                item.name == "完善个人信息" ||
                item.name == "设置兴趣分类"
              ) {
                item.link = "/user/userinfo";
              } else if (
                item.name == "首次购物成功" ||
                item.name == "首次评价完成"
              ) {
                item.link = "/";
              } else if (item.name == "邀请好友注册") {
                item.link = "/user/invit";
              } else {
                item.link = "/user/orders";
              }
            }
          }
        });
      this.axios
        .get(this.serve + "/personal/integral_log", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.data) {
            this.list = res.data.data.results;
            this.total = res.data.data.total;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#score {
  margin-top: -38px;
  .r1 {
    margin: 40px 0;
    line-height: 1.5em;
  }
  .btn2 {
    float: right;
    position: relative;
    top: -3em;
  }
  .sRow {
    padding: 5px 50px;
    line-height: 25px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 10px;
  }
}
</style>